export const FETCH_AI_ANALYSIS_REQUEST='FETCH_AI_ANALYSIS_REQUEST';
export const FETCH_AI_ANALYSIS_SUCCESS='FETCH_AI_ANALYSIS_SUCCESS';
export const FETCH_AI_ANALYSIS_FAILURE='FETCH_AI_ANALYSIS_FAILURE';